import { HomeLoaderResponse } from "../../interfaces/loaders";
import { fuldtNavn } from "../../lib/stamdataNavn";

export const getIdKortInitialValues = ({
  userInfo,
  stamdata,
}: Pick<HomeLoaderResponse, "userInfo" | "stamdata">) => {
  // Faldbakken til tokenets navn er kun her: de øvrige kaldere af fuldtNavn har ikke et userInfo at
  // falde tilbage på.
  const fuldeNavn = fuldtNavn(stamdata) || userInfo?.navn?.trim() || "";

  const firmanavn = stamdata?.firmanavn?.trim() || "";

  return { fuldeNavn, firmanavn };
};
